<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <z-page title="Pemungutan Semen Ternakan">
      <w-card bg-color="" class="">
        <div class="w-flex wrap smd-column">
          <div class="mx2"></div>
          <div class="grow ">
            <div class="w-flex wrap smd-column">
              <div class="grow ">
                <table>
                  <tbody>
                    <tr class="row_data">
                      <td><b>Tarikh Pemungutan</b></td>
                      <td><b>:</b></td>
                      <td>{{ $zutil.dateformat(data.tarikh)}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>ID Ternakan</b></td>
                      <td><b>:</b></td>
                      <td>{{data.ternakan}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Jumlah Panjatan Palsu</b></td>
                      <td><b>:</b></td>
                      <td>{{data.jumlah_penjatan_palsu}}</td>
                    </tr>
                    <!-- <tr class="row_data">
                      <td><b>Bil. Pungutan</b></td>
                      <td><b>:</b></td>
                      <td>{{data.bil_pungutan}}</td>
                    </tr> -->
                    <tr class="row_data">
                      <td><b>Warna Benih</b></td>
                      <td><b>:</b></td>
                      <td>{{data.warna}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Nama Operator</b></td>
                      <td><b>:</b></td>
                      <td>{{data.name}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Catatan</b></td>
                      <td><b>:</b></td>
                      <td>{{data.catatan}}</td>
                    </tr>
                  </tbody>
               </table>
              </div>
              <div class="mx2"></div>
              <div class="grow ">
                <table>
                  <tbody>
                    <tr class="row_data">
                      <td><b>Nombor Batch</b></td>
                      <td><b>:</b></td>
                      <td>{{data.no_batch}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Masa Pungutan</b></td>
                      <td><b>:</b></td>
                      <td>{{data.masa}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Nombor Ejakulasi</b></td>
                      <td><b>:</b></td>
                      <td>{{data.lkp_ejakulasi}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Tujahan (0-5)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.tujahan}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Libido (0-10)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.libido}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Isipadu (ml)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.isipadu}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Skor Ketumpatan (0-5)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.skor_ketumpatan}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br>
          </div>
        </div>
      </w-card>
      <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
  extends: ZResource,
  components: {
    VueperSlides, VueperSlide
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      resourceurl: 'se.pemungutan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Pemungutan Semen Ternakan', route: '/se/pemungutan' },
        { label: 'Papar', route: '/se/pemungutan/'+this.id },
      ],
      data : {id : 0},
      attahecment : [],
      slides : [],
      activeTab : 0,
      tabs: [
        { title: 'Pemungutan', content: '' },
      ]
    }
  },
  methods: {
    getData()
    {
      this.$zcomm.get(this.api_service + 'se_pemungutan/show/'+this.id, {}).then(res => {
        this.data = res
        this.getAttahecment()
      })
    },
    tutup(){
      this.$inertia.visit(window.route('se.pemungutan.index'));
    },
    getAttahecment()
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.data.id, model : '\\App\\Model\\SePemungutan'}).then(res => {
        this.attahecment = res
        this.slides = [];
       for (var b in this.attahecment) {
          this.slides.push({title: this.attahecment[b].information, image: this.attahecment[b].url})
       }
      })
    },
    uploadImg(item) 
    {  
       let formData = new FormData();
       for (var b in this.files) 
       {
           formData.append("files["+b+"]", this.files[b].file);
       }
       formData.append("model",item);
       formData.append("model_id", this.data.id);
       this.$zcomm.post('attahecment.upload', formData)
           .then((res) => {
               this.getAttahecment();
           })
           .catch((err) => {})
           .finally(() => {});
   },
   deletelAttahecment(id)
   {
    if (confirm('Are you sure to delete this record?')) {
       this.$zcomm.get(this.$route('attahecment.delete', id), {})
       .then(res => {
        this.getAttahecment();
       })
     }
   },
  },
  watch: {
  },
  mounted() {
    this.getData();
  },
}
</script>
<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

.row_data td {
  padding: 6px 4px;
  font-size: 14px;
  color: #333;
  vertical-align: top;
}

.row_data td:first-child {
  width: 190px;       
  font-weight: 600;
  padding-right: 10px;
}

.row_data td:nth-child(2) {
  width: 12px;
  text-align: center;
  font-weight: bold;
}

.row_data td:last-child {
  font-weight: 500;
}
</style>